import { Controller } from "stimulus"

// Hides the "recovered" input when the selected core size is non-recoverable.
export default class extends Controller {

    static targets = ["core", "recovered"]

    connect() {
        this.toggle()
    }

    toggle() {
        const nonRecoverableIds = JSON.parse(this.coreTarget.dataset.nonRecoverableIds || '[]')
        const isNonRecoverable = nonRecoverableIds.includes(+this.coreTarget.value)

        this.recoveredTarget.hidden = isNonRecoverable

        if (isNonRecoverable) {
            const input = this.recoveredTarget.querySelector('input')
            if (input) {
                input.value = ''
            }
        }
    }
}
